import { FinanceOverviewItem } from "../types/FinanceOverviewItem";
import { ProjectCheck } from "../types/ProjectCheck";

export function filterBySearch<
  T extends Pick<
    ProjectCheck | FinanceOverviewItem,
    "clientName" | "projectNumber" | "projectTitle"
  >,
>(search: string, list: T[]): T[] {
  if (search && search.trim() !== "") {
    return list.filter(
      (item) =>
        item.clientName.toLowerCase().includes(search) ||
        item.projectNumber.toLowerCase().includes(search) ||
        item.projectTitle.toLowerCase().includes(search),
    );
  }
  return list;
}
